import rill from "rill";
import set from "@rill/set";

import {
  getRoot,
  postInviteAthlete,
  postCancelInvite,
  postResendInvite,
  postNewGroup,
  postUpdateGroupForOrganizations,
  deleteGroup,
  postUpdateGroup,
  acknowledgeAthlete,
} from "./athletes.controller.js";

const Athletes = (app) => {
  app.at(
    "/athletes/*",
    rill()
      .use(set("heading", ["Coaching", "Athletes"]))
      .setup((app) => {
        app
          .get("/", getRoot)
          .post("/invite-athlete", postInviteAthlete)
          .post("/cancel-invite", postCancelInvite)
          .post("/resend-invite", postResendInvite)
          .post("/new-group", postNewGroup)
          .post("/delete-group", deleteGroup)
          .post("/update-group", postUpdateGroup)
          .post("/organization-update-group", postUpdateGroupForOrganizations)
          .post("/acknowledge-athlete", acknowledgeAthlete);
      })
  );
};

export default Athletes;
